// import React, { useEffect, useState } from 'react';
const {
  has,
  get,
  map,
  remove,
  first,
  difference,
  dropWhile,
  includes,
  isEqual,
  chunk,
} = lodash;
// import { plus as linkIcon } from '@wordpress/icons';
// import {smileIcon} from '../../icons/custom'
import { AmzonImg, AmazonSelectImg, AmazonSelectExt, AmazonLink,AmazonAffiliateLink, AmazonSearchLink } from "../common";
//import {Box, Avatar,LinearProgress,Grid, Paper,Divider, List, ListItem , ListItemText,Select,MenuItem,TextField,Slider, FormGroup   } from '@material-ui/core'
//import Alert from "@material-ui/lab/Alert";
import { SortFilter } from "./data";
//import { VerticalAlignBottom } from '@material-ui/icons';
// import CssBaseline from '@material-ui/core/CssBaseline';
// import {AZCard} from './azcard'
// import {AZDbCard} from './azdbcard'
const {RichTextToolbarButton } = wp.blockEditor;
const { useState, useEffect } = wp.element;
const { toggleFormat,applyFormat,removeFormat,insert,create } = wp.richText;
const {
  Flex,
  FlexItem,
  FlexBlock,
  ExternalLink,
  ToggleControl,
  Notice,
  RangeControl,
  SelectControl,
  TextControl,
	Button,
	ButtonGroup,
  Modal,
  Spinner,
  Card,
  CardBody,
  CardDivider,
  CardFooter,
  CardHeader,
  CardMedia,
} = wp.components;
const { apiFetch } = wp;
const { __ } = wp.i18n;

export const MZSearchDialog = ({
  item_ids,
  products,
	updateValue,
	formaterProps,
	isSingle = false,
	isFormater = false,
} = props) => {
  // const classes = useStyles();
  const [open, setOpen] = useState(false);

  const [searchFilter, setSearchFilter] = useState({
    term: "",
    rating: 4,
    minPrice: 40,
    maxPrice: 0,
    minSavingPercent: 0,
    sortBy: "Featured",
    categoryId: "all",
  });
  const [categories, setCategories] = useState([
    { value: "all", label: "All Category" },
  ]);
  const [categoryId, setCategoryId] = useState("all");

  const [loading, setLoading] = useState(false);
  const [fromServer, setFromServer] = useState(true);
  const [openNewWindow, setOpenNewWindow] = useState(true);
  const [allowLoadFromServer, setAllowLoadFromServer] = useState(false);

  const [pageCount, setPageCount] = useState(0);
  const [data, setData] = useState(null);
  const [page, setPage] = useState(0);
  const [error, setError] = useState(null);
  const [hasLink, setHasLink] = useState(null);
  

  useEffect(() => {
    if (searchFilter.term.length > 0) {
      startSearch();
    }
  }, [categoryId]);

  useEffect(() => {
    updateProducts();
  }, [item_ids]);

  useEffect(() => {
    //console.log(fromServer);
    if (allowLoadFromServer && (!fromServer || (fromServer &&  searchFilter.term.length > 2))) {
      getSearchResult(0);
		}
		
  }, [fromServer]);

  useEffect(() => {
    let fs = localStorage.getItem("fromServer");
    setFromServer(fs == "true");
    setAllowLoadFromServer(true);
  }, []);

  useEffect(() => {
    if ((searchFilter.term.length > 0 || !fromServer) && page > 0) {
      getSearchResult();
    }
  }, [page, open]);

  const getSearchResult = (pos) => {
    if (open && !loading) {
      setError(null);
      let curPage = pos != 0 ? page : pos;
      let term = searchFilter.term.length > 0 ? searchFilter.term : "NOTERM";
      setLoading(true);
      apiFetch({
        path:
          "/i2-azon/v1/search/" +
          term +
          "?si=" +
          searchFilter.categoryId +
          "&page=" +
          curPage +
          // "&rating=" +
          // searchFilter.rating +
          // "&minPrice=" +
          // searchFilter.minPrice * 100 +
          // "&maxPrice=" +
          // searchFilter.maxPrice * 100 +
          // "&minSavingPercent=" +
          // searchFilter.minSavingPercent +
          "&sortBy=" +
          searchFilter.sortBy +
          "&sourceRemote=" +
          fromServer,
      }).then((data) => {
       // console.log(data);
        if (has(data, "Errors")) {
          // console.log(get(data, "Errors[0].Message"));
          setError(get(data, "Errors[0].Message"));
          setData(null);
          setLoading(false);
        } else {
          if (categories.length < 2) {
            let bins = get(
              data,
              "SearchResult.SearchRefinements.SearchIndex.Bins",
              []
            );
            let forCategory = [{ value: "all", label: "All Category" }];
            if (bins.length > 0) {
              bins.map((item) =>
                forCategory.push({
                  value: item.Id,
                  label: item.DisplayName,
                })
              );
              setCategories(forCategory);
            }
          }
          // console.log('SearchResult.TotalResultCount');
          // console.log(get(data,'SearchResult.TotalResultCount', 0));
          let resutlCount = get(data, "SearchResult.TotalResultCount", 0);
          resetPageCount(resutlCount);
          setData(data);
          // console.log("data loaded");
          // console.log(data);
          // loading = false
          if(resutlCount == 0){
            if(!fromServer && searchFilter.term.length > 0){
              setError(__('No result found, search on amazon ', 'themesfirst'));
              setHasLink(true)
            }else{
              setError(__('No result found', 'themesfirst'));
            }
          }
          setLoading(false);
        }
      });
    }
  };

  const resetPageCount = (val) => {
    if (val >= 100) {
      setPageCount(10);
    } else {
      setPageCount(val > 10 ? parseInt(val / 10) + (val % 10 > 0 ? 1 : 0) : 0);
    }
  };

  const changePage = (val) => {
    //	page = page + val;
    if (page == 1 && val == 1) {
      setPage(0);
      getSearchResult(0);
    } else {
      setPage(val - 1);
    }
  };
  const startSearch = () => {
    if (page > 0) {
      setPage(0);
    }
    getSearchResult(0);
  };
  //  After Finalize the function
  const updateAsin = (action, asin, title = '') => {
	 
		if(isFormater){

			if(formaterProps.value.start == formaterProps.value.end){
				const toInsert = applyFormat(
					create( { text: title + " "} ),
					{ type: "themesfirst/amazonlinkformat",
								attributes: { href: AmazonAffiliateLink(asin), target : openNewWindow ? "_blank" : "_self", rel : "nofollow noopener noreferrer" }, 
					 },
					0,
					title.length
				);
				formaterProps.onChange( insert( formaterProps.value, toInsert ))
			}else{
			formaterProps.onChange( 
				applyFormat(
					formaterProps.value,                
							{ type: "themesfirst/amazonlinkformat",
								attributes: { href: AmazonAffiliateLink(asin), target : openNewWindow ? "_blank" : "_self" , rel : "nofollow noopener noreferrer" }, 
							}
					)
			);
		}
			setOpen(false) 

		}else{
    if (action == "add") {
      if (!isSingle) {
        updateValue({ item_ids: [...item_ids, asin] });
      } else {
        updateValue({ item_ids: [asin] });
      }
    } else if(action == "delete") {
      removeItem(asin);
    }else {
      remove(item_ids, function (x) {
        return isEqual(x, asin);
      });
      updateValue({ item_ids: [...item_ids] });
    }
		//console.log(action, asin);
		}
  };
  // const removeProduct = (asin) => {
  //   console.log("request for remove ... " + asin);
  //   const obj = [...products];
  //   let pIndex = findIndex(obj, { asin: asin });
  //   if (pIndex > -1) {
  //     obj.splice(pIndex, 1);
  //     updateValue({ products: obj });
  //   }
  // };

  // new working changs
  // =====================================================================================================//

  const updateProducts = () => {
    let product_asin = map(products, "asin");
    const product_to_remove = difference(product_asin, item_ids);
    const product_to_load = difference(item_ids, product_asin);

    if (product_to_remove.length > 0) {
      // console.log("=============");
      // console.log("product to remove : ");
      // console.log(product_to_remove);
      // console.log("=============");
      let newProds = dropWhile(products, function (x) {
        return includes(product_to_remove, x.asin);
      });
     // console.log(newProds);
      updateValue({ products: newProds });
    }
    if (product_to_load.length > 0) {
      // console.log("=============");
      // console.log("goin to fetch : ");
      // console.log(product_to_load);
      // console.log("=============");
      fetchContent(product_to_load.join(","));
    }
  };

  const fetchContent = (asins) => {
    apiFetch({ path: "/i2-azon/v1/contents/" + asins }).then((items) => {
      if (items != null) {
        var newProd = isSingle ? [] : [...products];

        items.map((obj) => {
          var item = obj;
          item.active_image_Index = 0;
          var images = JSON.parse(obj.image_ids);
          if (images.length > 0) {
           // item.images = images;
           delete item.image_ids;
            item.image = images[0];
          }
          newProd.push(item);
        });

       // console.log(newProd);
        updateValue({ products: newProd });
      }
    });
  };

  const removeItem = (asin) => {
    apiFetch({ path: "/i2-azon/v1/delete/" + asin }).then((data) => {
     // console.log(data);
       if(data == 1){
        remove(item_ids, function (x) {
          return isEqual(x, asin);
        });
        updateValue({ item_ids: [...item_ids] });
        getSearchResult(page);

       }else{
        setError(__('Error on removing product, please try again','themefirst'));
       }

      // if (items != null) {
      //   var newProd = isSingle ? [] : [...products];

      //   items.map((obj) => {
      //     var item = obj;
      //     item.active_image_Index = 0;
      //     var images = JSON.parse(obj.image_ids);
      //     if (images.length > 0) {
      //       item.images = images;
      //       item.image = images[0];
      //     }
      //     newProd.push(item);
      //   });

      //   console.log(newProd);
      //   updateValue({ products: newProd });
      // }
    });
  };
  // end new changes
  const updateServer = (val) => {
    localStorage.setItem("fromServer", val);
    setData(null);
    setFromServer(val);
  };

  return (
    <>
		  {isFormater ? 
			<>
			<RichTextToolbarButton  
			 icon= {formaterProps.isActive? 'editor-unlink' : 'admin-links'}
			// icon= {smileIcon}			 
			 title={__('Amazon link', 'themesfirst')}
       onClick={ () => { 
				 formaterProps.isActive ? 
				 formaterProps.onChange(  toggleFormat(
					formaterProps.value,
					{ type: 'themesfirst/amazonlinkformat' } ))
				   :  
						setOpen(true) } 
					}
				group="primary"
       isActive={ formaterProps.isActive }
      /> </> : 
      <Flex>
        <span> 
        <Button variant="outlined" isPrimary onClick={(obj) => setOpen(true)}>
          {__("Search Products", "themesfirst")}
        </Button>
        </span>
				{item_ids.length > 0 &&
        <Button
          icon="image-rotate"
          isSecondary
          size="24"
					isBusy={loading}					
          variant="outlined"
          onClick={updateProducts}
          disabled={difference(item_ids, map(products, "asin")).length == 0}
        ></Button>}
      </Flex> }
      {open && (
        <Modal
          open={open}
          title={__("Search Products", "themesfirst")}
          onRequestClose={() => setOpen(false)}
          aria-labelledby="form-dialog-title"
          style={{width: '90%', maxWidth: '1080px'}}
        >
          <figure style={{ minHeight: "400px" }}>
            <Flex className="tf-top-pagination-wrapper">
              <FlexItem>
                <Flex>
                <FlexItem>
                <ToggleControl
                  label="Use API?"
                  help={fromServer ? __('Active Server Amazon API', 'themesfirst')  : __('Active Server Local DB', 'themesfirst')}
                  checked={fromServer}
                  onChange={() => updateServer(!fromServer)}
                />
                </FlexItem>
                {isFormater && <FlexItem>
                <ToggleControl
                  label="Open link in new tab?"
                  help={openNewWindow ? __('link will open in new tab', 'themesfirst')  : __('link will open in same tab', 'themesfirst')}
                  checked={openNewWindow}
                  onChange={() => setOpenNewWindow(!openNewWindow)}
                />
                </FlexItem>}
                </Flex>
                
                 
              </FlexItem>              
							{pageCount > 1 &&	<ButtonGroup style={{marginLeft:"auto"}}>
							 {page > 0 &&	<Button onClick={()=> changePage(page)} icon="arrow-left-alt2">{__('Prev', 'themesfirst')}</Button>}
								<Button isPrimary disabled={true} icon="editor-kitchensink" > &nbsp; {page + 1} {__('of', 'themesfirst')} {pageCount}</Button>
							 {page < pageCount - 1 &&	<Button onClick={()=> changePage(page + 2)} icon="arrow-right-alt2" iconPosition="right">{__('Next', 'themesfirst')}</Button>}
							</ButtonGroup>}
              {/* <FlexBlock style={{ marginLeft: "auto" }}>

                {pageCount > 1 && (
                  <Pagination
                    count={pageCount}
                    className={"MuiPagination-ul"}
                    disabled={loading}
                    color="primary"
                    page={page + 1}
                    onChange={(obj, pos) => changePage(pos)}
                  />
                )}
              </FlexBlock> */}
            </Flex>
            {loading && (
              <Flex justify="center">
                <FlexBlock style={{ minHeight: "50px", textAlign: "center" }}>
                  <Spinner />
                </FlexBlock>
              </Flex>
            )}
            {error && (
              <Notice status="error" onRemove={() => {setError(null), setHasLink(null)}}>
                {error} {hasLink && <ExternalLink href={AmazonSearchLink(searchFilter.term)}>{searchFilter.term}</ExternalLink>}
              </Notice>
            )}

            <div style={{ marginTop: "15px", marginBottom: "15px" }}>
              {/* <div className="tf-sub-title">
           <h4>{__('Search the product which you want to publish on the website', 'themesfirst')}</h4>
          </div> */}
              <Flex className="tf-flex-sf-container">
                <FlexItem>
                  <TextControl
                    label={__("Search Terms", "themesfirst")}
                    value={searchFilter.term}
                    onChange={(obj) =>
                      setSearchFilter({ ...searchFilter, term: obj })
                    }
                  />
                </FlexItem>
                <FlexItem>
                  {fromServer && (
                    <SelectControl
                      label={__("Sort By", "themesfirst")}
                      value={searchFilter.sortBy}
                      onChange={(obj) => {
                        setSearchFilter({ ...searchFilter, sortBy: obj });
                      }}
                      options={SortFilter}
                    />
                  )}
                </FlexItem>
                <FlexItem>
                  <Button
                    icon="search"
                    isBusy={loading}
                    className="tf-full-button"
                    style={{ marginBottom: "8px" }}
                    disabled={fromServer && searchFilter.term.length < 3}
                    isPrimary
                    onClick={() => startSearch()}
                  >
                    {__("Search", "themesfirst")}
                  </Button>
                </FlexItem>
              </Flex>
            </div>

            {data &&
              data.SearchResult.Items.length > 0 &&
              chunk(data.SearchResult.Items, 3).map((items) => {
                return (
                  <Flex justify="center" style={{ marginBottom: "10px" }}>
                    {items.map((item) => (
                      <FlexItem
                        style={{ maxWidth: "33%", alignSelf: "flex-start" }}
                      >
                        {fromServer ? (
                          <Card className="tf-card">
                            {item_ids.indexOf(get(item, "ASIN")) == -1 ? (
                              <Button
                                icon="plus"
                                isSecondary
                                size="24"
                                onClick={(obj) =>
                                  updateAsin("add", get(item, "ASIN"), get(
																		item,
																		"ItemInfo.Title.DisplayValue",
																		"No Title"
																	))
                                }
                                className="tf-card-button tf-button-add"
                              ></Button>
                            ) : (
                              <Button
                                icon="minus"
                                isSecondary
                                size="24"
                                onClick={(obj) =>
                                  updateAsin("remove", get(item, "ASIN"))
                                }
                                className="tf-card-button tf-button-minus"
                              ></Button>
                            )}
                            <CardMedia className="tf-card-image">
                              <img
                                src={get(item, "Images.Primary.Large.URL", "#")}
                              />
                            </CardMedia>
                            <CardBody size="small">
                              <strong style={{marginTop:0, display: 'block'}}>ASIN :  
                              {
                                get(item, 'ASIN', 'no asin')
                              }</strong>
                              {get(
                                item,
                                "ItemInfo.Title.DisplayValue",
                                "No Title"
                              )}
                              <CardDivider className="tf-card-devider" />
                              {
                                first(item.BrowseNodeInfo.BrowseNodes)
                                  .ContextFreeName
                              }
                            </CardBody>
                            <CardFooter size="small">
                              <FlexItem>
                                {has(
                                  item,
                                  "Offers.Listings[0].SavingBasis.DisplayAmount"
                                ) ? (
                                  <span>
                                    <s>
                                      {get(
                                        item,
                                        "Offers.Listings[0].SavingBasis.DisplayAmount"
                                      )}
                                    </s>{" "}
                                    &nbsp;{" "}
                                  </span>
                                ) : (
                                  ""
                                )}
                                <b>
                                  {get(
                                    item,
                                    "Offers.Listings[0].Price.DisplayAmount",
                                    "No Price"
                                  )}
                                </b>
                              </FlexItem>
                              <FlexItem style={{ marginLeft: "auto" }}>
                                <ExternalLink
                                  href={get(item, "DetailPageURL")}
                                ></ExternalLink>
                              </FlexItem>
                            </CardFooter>
                          </Card>
                        ) : (
                          <Card className="tf-card">
                            {item_ids.indexOf(get(item, "asin")) == -1 ? (
                              <Button
                                icon="plus"
                                isSecondary
                                size="24"
                                onClick={(obj) =>
                                  updateAsin("add", get(item, "asin"), get(item, "title", ''))
                                }
                                className="tf-card-button tf-button-add"
                              ></Button>
                            ) : (
                              <Button
                                icon="minus"
                                isSecondary
                                size="24"
                                onClick={(obj) =>
                                  updateAsin("remove", get(item, "asin"))
                                }
                                className="tf-card-button tf-button-minus"
                              ></Button>
                            )}
                              <Button
                                icon="trash"
                                isSecondary
                                size="24"
                                onClick={(obj) =>
                                  updateAsin("delete", get(item, "asin"))
                                }
                                className="tf-card-button tf-button-minus tf-button-trash"
                              ></Button>
                            <CardMedia className="tf-card-image">
                              <AmzonImg
                                imageUrl={AmazonSelectImg(
                                  get(item, "image_ids", "#")
																)}
																ext={AmazonSelectExt(
                                  get(item, "image_ids", "#")
																)}
                              ></AmzonImg>
                            </CardMedia>
                            <CardBody size="small">
                            <strong style={{marginTop:0, display: 'block'}}>ASIN :  
                              {
                                get(item, 'asin', 'no asin')
                              }</strong>
                              {get(item, "title", "No Title")}
                            </CardBody>
                            <CardFooter size="small">
                              <FlexItem>
                                {has(item, "saving") ? 
                                  <span>
                                    <s>{get(item, "saving")}</s> &nbsp;{" "}
                                  </span>
                                 : ""
                                }
                                <b>{get(item, "display_price", __('No Price', 'themesfirst'))}</b>
                              </FlexItem>
                              <FlexItem style={{ marginLeft: "auto" }}>
                                <ExternalLink
                                  href={AmazonLink(get(item, "asin"))}
                                ></ExternalLink>
                              </FlexItem>
                            </CardFooter>
                          </Card>
                        )}
                      </FlexItem>
                    ))}
                  </Flex>
                );
              })}
          </figure>
        </Modal>
      )}
    </>
  );
};
